import { RaffleStatus } from "./Raffle.types";

export function getRaffleStatus(timeLeftToStartInSeconds: number): RaffleStatus {
  if (timeLeftToStartInSeconds < -15 * 60) {
    return "ended";
  }

  if (timeLeftToStartInSeconds < 15 * 60) {
    return "ongoing";
  }

  return "upcoming";
}
